import React from 'react';
import { standardizeLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { IntlProvider } from '@atlassian/jira-intl/src/intl-provider.tsx';
import type { IntlProvidersProps } from './types.tsx';

export const IntlProviders = ({ children, locale, messages }: IntlProvidersProps) => (
	<IntlProvider messages={messages} locale={standardizeLocale(locale)}>
		{children}
	</IntlProvider>
);
